module.exports = __webpack_public_path__ + "static/media/google_play_ico.db6e3709.svg";